/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, View, type ViewStyle } from 'react-native';
import { surfaceCardStyles as styles } from './surfaceCards.styles';

type Props = {
  title: string;
  hint?: string;
  children: React.ReactNode;
  wrapStyle?: ViewStyle;
  subsection?: React.ReactNode;
};

/** Tablero KPI operativo (Informes ventas, Personal, Caja). */
export function KpiStrip({ title, hint, children, wrapStyle, subsection }: Props) {
  return (
    <View style={[styles.kpiShell, wrapStyle]}>
      <View style={styles.kpiHeader}>
        <Text style={styles.kpiHeaderTitle}>{title}</Text>
        {hint ? <Text style={styles.kpiHeaderHint}>{hint}</Text> : null}
      </View>
      {children}
      {subsection ? <View style={styles.kpiSubsection}>{subsection}</View> : null}
    </View>
  );
}

export function KpiStripGrid({ children, style }: { children: React.ReactNode; style?: ViewStyle }) {
  return <View style={[styles.kpiGrid, style]}>{children}</View>;
}

export function KpiStripCell({
  label,
  value,
  wide,
  warning,
  allowWrap,
  style,
}: {
  label: string;
  value: string;
  wide?: boolean;
  warning?: boolean;
  /** Valores largos (CUIT): permitir varias líneas en lugar de truncar. */
  allowWrap?: boolean;
  style?: ViewStyle;
}) {
  return (
    <View
      style={[
        styles.kpiCell,
        wide && styles.kpiCellWide,
        allowWrap && styles.kpiCellWrap,
        warning && { borderColor: 'rgba(250, 204, 21, 0.42)' },
        style,
      ]}
    >
      <Text style={styles.kpiCellLabel}>{label}</Text>
      <Text
        style={[styles.kpiCellValue, allowWrap && styles.kpiCellValueWrap]}
        numberOfLines={allowWrap ? 2 : 1}
        adjustsFontSizeToFit={!allowWrap}
        minimumFontScale={0.75}
      >
        {value}
      </Text>
    </View>
  );
}
